<template>
  <div class="CarouselMap" v-if="$props.spaces">
    <carousel class="CarouselMap__carousel" :items="1"
              :autoplay="false"
              :loop="false"
              :dots="false"
              :center="true"
              :margin="20">
      <template slot="prev">
        <span class="nav-btn prev-slide">
          <svg xmlns="http://www.w3.org/2000/svg" width="18.953" height="10.703" viewBox="0 0 18.953 10.703">
            <path id="Tracé_147499" data-name="Tracé 147499" d="M6.287,24.286l-.346.345,4.552,4.084H-6.22v.473H10.493L5.941,33.274l.346.341,5.2-4.663Z" transform="translate(12.233 34.3) rotate(180)" fill="#f6f3f3" stroke="#fff" stroke-width="1"/>
          </svg>
        </span>
      </template>

      <template v-for="space in $props.spaces">
        <div v-for="item in space.items"
             class="CarouselMap__item">

          <div class="CarouselMap__icon" v-html="item.iconMobile"></div>

          <template v-if="$enums.SpaceTypes.STUDIO === item.type">
            <div class="CardMap__title" :class=" !item.url ? 'm-b-0' : ''">

              <div v-if="item.label"
                   class="CardMap__label">
                <div v-html="item.label"></div>
              </div>

              <div v-if="item.number"
                   v-html="item.number"
                   class="CardMap__number"></div>

              <div>
                <span v-if="item.info"
                      v-html="item.info"
                      class="CardMap__name"></span>
                <p v-if="item.price"
                      v-html="item.price"
                      class="CardMap__price m-t-10"></p>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="CardMap__title CardMap__lite" :class=" !item.label ? 'CardMap__title-withoutLabel' : ''">
              <div v-if="item.label"
                   class="CardMap__lite-label">
                <div v-html="item.label"></div>
              </div>
              <div v-if="item.name || item.price || item.description"
                   :class=" !item.label ? 'CardMap__title-lite' : ''">
                <span v-if="item.name"
                      v-html="item.name"
                      class="CardMap__lite-name"
                      :class="(item.price || item.description) ? 'm-b-10' : ''"></span>
                <p v-if="item.price"
                      v-html="item.price"
                      class="CardMap__lite-price"></p>
                <p v-if="item.description"
                      v-html="item.description"
                      class="CardMap__lite-description"></p>
              </div>
            </div>
          </template>

          <a v-if="item.url && item.label_button" :href="item.url" class="CardMap__action Btn Btn__secondary" >
            <span>{{ item.label_button }}</span>
          </a>
        </div>
      </template>

      <template slot="next">
        <span class="nav-btn next-slide">
          <svg xmlns="http://www.w3.org/2000/svg" width="18.953" height="10.703" viewBox="0 0 18.953 10.703">
            <path id="Tracé_147498" data-name="Tracé 147498" d="M6.287,24.286l-.346.345,4.552,4.084H-6.22v.473H10.493L5.941,33.274l.346.341,5.2-4.663Z" transform="translate(6.72 -23.597)" fill="#f6f3f3" stroke="#fff" stroke-width="1"/>
          </svg>
        </span>
      </template>
    </carousel>
  </div>
</template>

<script>
import carousel from 'vue-owl-carousel'

export default {
  name: 'carousel-map',
  props: {
    spaces: {
      type: Array,
      required: true
    }
  },
  components: {
    carousel
  },
  data() {
    return {
      items: null
    }
  },
  mounted() {
    this.$props.spaces
  }
}
</script>